// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3111b","row":"Node_row__HFsjy","label":"Node_label__2AOsI","footer":"Node_footer__RiVA5"};